/**
 * LoadAnchor
 * @class
 */
class LoadAnchor {

  /**
   * @static
   */
  static get defOpts() {
    return {
      offset: -120,
    }
  }

  /**
   * @param _opts {object}
   */
  constructor(_opts = {}) {
    const { offset } = _.defaults(_opts, LoadAnchor.defOpts);

    const hash_ = location.hash;

    if(!hash_) return;

    this.$el    = document.getElementById(hash_.replace('#', ''));
    this.offset = offset;

    window.addEventListener('load', this.scroll.bind(this));
  }

  scroll() {
    const winY_ = window.pageYOffset;
    const rect_ = this.$el.getBoundingClientRect();
    const y_    = rect_.top + winY_;

    setTimeout(() => {
      window.scrollTo(0, (y_ + this.offset));
    }, 100);
  }

}

/**
 * class exports
 */
module.exports = LoadAnchor;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/pc/ui/load-anchor.js
 **/